import { AgentType } from "@superblocksteam/shared";

export function isManagedNativeDatabasesAvailable({
  managedNativeDbEnabled,
  organization,
}: {
  managedNativeDbEnabled: boolean;
  organization?: { agentType?: AgentType } | null;
}) {
  return (
    managedNativeDbEnabled && organization?.agentType === AgentType.ONPREMISE
  );
}
